const formatPrice = (value) => {
  if (!value) {
    return "";
  }
  const formattedNumber = parseFloat(value).toFixed(2);
  const parts = formattedNumber.split('.');
  let integerPart = parts[0];
  const decimalPart = parts[1];

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return `${integerPart},${decimalPart}`;
}

export default formatPrice;



// WEBPACK FOOTER //
// ./src/filters/modules/formatPrice.js